var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwladLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.557,
    height: 171.994,
    viewBox: "0 0 168.557 171.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AWLAD_V2",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6364",
    "data-name": "Groupe 6364",
    transform: "translate(2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "KALIMAT_IMAGE",
    "data-name": "KALIMAT IMAGE",
    d: "M22.91,0H149.647c11.548,0,20.91,10.266,20.91,22.931V149.063c0,12.664-9.362,22.931-20.91,22.931H22.91C11.362,171.992,2,161.727,2,149.063V22.931C2,10.267,11.362,0,22.91,0Z",
    transform: "translate(-2 0)",
    fill: "#eac676"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AWLAD_SCHOOL",
    "data-name": "AWLAD SCHOOL",
    transform: "translate(18.264 18.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4631",
    "data-name": "Path 4631",
    d: "M21.634,19.37a10.316,10.316,0,0,1-1.887,2.2,15.56,15.56,0,0,1-2.39,1.761,15.322,15.322,0,0,1-2.767,1.195,9.355,9.355,0,0,1-2.956.44,11.218,11.218,0,0,1-7.484-2.578,10.9,10.9,0,0,1-2.327-2.767,13.3,13.3,0,0,1-1.384-3.4A14.285,14.285,0,0,1,0,12.515,14.285,14.285,0,0,1,.5,8.8a16.036,16.036,0,0,1,1.384-3.4,11.187,11.187,0,0,1,2.327-2.83A10.279,10.279,0,0,1,7.421.692,12.216,12.216,0,0,1,11.572,0,11.676,11.676,0,0,1,14.59.377a10.112,10.112,0,0,1,2.7,1.069,10.941,10.941,0,0,1,2.327,1.887,12.544,12.544,0,0,1,2.012,2.83L16.1,8.8A3.835,3.835,0,0,0,15.282,7.8a4.343,4.343,0,0,0-1.258-.818,5.372,5.372,0,0,0-1.509-.566,5.171,5.171,0,0,0-1.7-.126,5.6,5.6,0,0,0-2.264.692A4.04,4.04,0,0,0,6.981,8.49,7.386,7.386,0,0,0,6.037,10.5a9.353,9.353,0,0,0-.314,2.264,6.477,6.477,0,0,0,.377,2.2,7.161,7.161,0,0,0,1.006,1.95A5.294,5.294,0,0,0,8.8,18.3a4.788,4.788,0,0,0,2.39.5,6.7,6.7,0,0,0,3.019-.755,9.007,9.007,0,0,0,1.384-.943,5.719,5.719,0,0,0,1.132-1.321Z",
    transform: "translate(32.073 35.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4632",
    "data-name": "Path 4632",
    d: "M11.634,24.967a11.218,11.218,0,0,1-7.484-2.578,10.9,10.9,0,0,1-2.327-2.767,13.3,13.3,0,0,1-1.384-3.4A14.285,14.285,0,0,1,0,12.515,14.285,14.285,0,0,1,.5,8.8a16.037,16.037,0,0,1,1.384-3.4,11.188,11.188,0,0,1,2.327-2.83A10.278,10.278,0,0,1,7.421.692,11.952,11.952,0,0,1,11.572,0a11.385,11.385,0,0,1,3.962.692,8.215,8.215,0,0,1,3.019,1.887,13.75,13.75,0,0,1,2.2,2.767,13.638,13.638,0,0,1,1.321,3.333,14.133,14.133,0,0,1,.44,3.648,13.806,13.806,0,0,1-.44,3.648,13.133,13.133,0,0,1-1.321,3.4,11.99,11.99,0,0,1-2.138,2.767A9.825,9.825,0,0,1,15.6,24.024,7.849,7.849,0,0,1,11.634,24.967ZM10.817,6.352a5.028,5.028,0,0,0-2.264.629A4.977,4.977,0,0,0,6.981,8.427a6.6,6.6,0,0,0-.943,2.012A9.353,9.353,0,0,0,5.723,12.7,7.121,7.121,0,0,0,6.1,14.968a6.354,6.354,0,0,0,1.006,1.95A5.293,5.293,0,0,0,8.8,18.3a4.788,4.788,0,0,0,2.39.5,4.76,4.76,0,0,0,3.962-2.012,5.7,5.7,0,0,0,.943-2.075,7.347,7.347,0,0,0,.252-2.327,13.825,13.825,0,0,0-.377-2.327A5.629,5.629,0,0,0,14.9,8.05a5.557,5.557,0,0,0-1.761-1.384A4.671,4.671,0,0,0,10.817,6.352Z",
    transform: "translate(79.177 35.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4633",
    "data-name": "Path 4633",
    d: "M11.634,24.967a11.218,11.218,0,0,1-7.484-2.578,10.9,10.9,0,0,1-2.327-2.767,13.3,13.3,0,0,1-1.384-3.4A14.286,14.286,0,0,1,0,12.515,14.285,14.285,0,0,1,.5,8.8a16.038,16.038,0,0,1,1.384-3.4,11.188,11.188,0,0,1,2.327-2.83A10.278,10.278,0,0,1,7.421.692,11.952,11.952,0,0,1,11.572,0a11.385,11.385,0,0,1,3.962.692,8.215,8.215,0,0,1,3.019,1.887,13.749,13.749,0,0,1,2.2,2.767,13.637,13.637,0,0,1,1.321,3.333,14.132,14.132,0,0,1,.44,3.648,13.806,13.806,0,0,1-.44,3.648,13.132,13.132,0,0,1-1.321,3.4,11.99,11.99,0,0,1-2.138,2.767A9.825,9.825,0,0,1,15.6,24.024,7.849,7.849,0,0,1,11.634,24.967ZM10.817,6.352a5.028,5.028,0,0,0-2.264.629A4.976,4.976,0,0,0,6.981,8.427a6.6,6.6,0,0,0-.943,2.012A9.354,9.354,0,0,0,5.723,12.7,7.121,7.121,0,0,0,6.1,14.968a6.354,6.354,0,0,0,1.006,1.95A5.293,5.293,0,0,0,8.8,18.3a4.788,4.788,0,0,0,2.39.5,4.76,4.76,0,0,0,3.962-2.012,5.7,5.7,0,0,0,.943-2.075,7.347,7.347,0,0,0,.252-2.327,13.823,13.823,0,0,0-.377-2.327A5.629,5.629,0,0,0,14.9,8.05a5.558,5.558,0,0,0-1.761-1.384A4.671,4.671,0,0,0,10.817,6.352Z",
    transform: "translate(104.521 35.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4634",
    "data-name": "Path 4634",
    d: "M6.54,33.457H0L.126,0H6.352Z",
    transform: "translate(129.488 27.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4635",
    "data-name": "Path 4635",
    d: "M18.552,25.218H13.521V15.156H4.968l.063,10.125H0V.063H4.78l.063,10.314H13.4V0h4.78Z",
    transform: "translate(56.537 35.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4636",
    "data-name": "Path 4636",
    d: "M4.591,17.106c0,4.4,2.767,6.6,8.553,6.6,4.842,0,9.685-1.258,11.7-3.459-.88-.943-2.578-1.761-5.22-3.207C15.848,14.968,13.4,13.9,13.4,11.509,13.4,4.214,18.615,0,24.527,0a8.741,8.741,0,0,1,5.22,1.761L28.111,6.415a8.714,8.714,0,0,0-4.025-1.132,7.083,7.083,0,0,0-6.729,4.276,30.207,30.207,0,0,0,5.283,3.27c4.842,2.641,5.974,4.339,5.974,6.666a7.2,7.2,0,0,1-2.075,5.346c-2.956,3.144-8.679,4.4-14.213,4.4C4.339,29.243,0,25.47,0,18.552a36.432,36.432,0,0,1,1.321-8.8l4.025.629A42.2,42.2,0,0,0,4.591,17.106Z",
    transform: "translate(0 34.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8267",
    "data-name": "Path 8267",
    d: "M25.085.262l5.063,1.25q-.062.37-.286,1.482t-.556,2.717q-.332,1.605-.749,3.6T27.7,13.423q-.44,2.123-.9,4.261l-.864,4.06q-.409,1.922-.756,3.5t-.579,2.57H17.984q-.139-.4-.324-1.135t-.409-1.69q-.224-.957-.479-2.1t-.54-2.37q-.286-1.227-.571-2.485t-.579-2.478q-.293,1.22-.587,2.485t-.571,2.493q-.278,1.227-.54,2.362T12.9,24.993q-.224.957-.417,1.683t-.316,1.142H5.542q-.232-.988-.579-2.57t-.756-3.5l-.864-4.045q-.455-2.13-.9-4.253t-.857-4.1Q1.173,7.379.841,5.773T.286,3.057Q.062,1.945,0,1.575L5.063.324,9.077,19.343l3.55-16.394h4.893l3.55,16.333Zm12.38,22.554H46.9v5.295H32.031V.077h5.218Zm28.342-.8-9.169-.062-2.146,6.653-4.863-1.914q.093-.293.363-1.119t.679-2.061q.409-1.235.918-2.786t1.073-3.273q.563-1.721,1.165-3.535l1.189-3.581q.587-1.768,1.127-3.4t1-2.995l.795-2.37q.34-1.011.509-1.521L63.646,0q.216.494.594,1.5T65.1,3.859q.486,1.358,1.05,3t1.173,3.427q.61,1.783,1.227,3.612t1.2,3.566q.579,1.737,1.1,3.3t.926,2.81q.409,1.243.687,2.076t.37,1.127L67.968,28.7Zm-7.24-5.295,5.31.015-2.655-8.46Z",
    transform: "translate(36.202 2.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8266",
    "data-name": "Path 8266",
    d: "M16.178,22.013l-9.169-.062L4.863,28.605,0,26.691q.093-.293.363-1.119t.679-2.061q.409-1.235.918-2.786t1.073-3.273Q3.6,15.73,4.2,13.917l1.189-3.581q.587-1.768,1.127-3.4t1-2.995L8.3,1.567Q8.645.556,8.814.046L14.017,0q.216.494.594,1.5t.864,2.362q.486,1.358,1.05,3T17.7,10.289q.61,1.783,1.227,3.612t1.2,3.566q.579,1.737,1.1,3.3t.926,2.81q.409,1.243.687,2.076t.37,1.127L18.339,28.7Zm-7.24-5.295,5.31.015-2.655-8.46Z",
    transform: "translate(14.872 1.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8265",
    "data-name": "Path 8265",
    d: "M18.956,13.852a13.691,13.691,0,0,1-.54,4.322,12.122,12.122,0,0,1-4.654,6.5,15.468,15.468,0,0,1-3.828,1.976,19.427,19.427,0,0,1-4.631,1A24.853,24.853,0,0,1,0,27.576V.144A30,30,0,0,1,5.025.074,20.2,20.2,0,0,1,9.5.892a15.133,15.133,0,0,1,3.782,1.744,11.641,11.641,0,0,1,2.941,2.717,12.619,12.619,0,0,1,1.937,3.728A16.992,16.992,0,0,1,18.956,13.852Zm-4.785,1.112a12.59,12.59,0,0,0-.455-3.62,8.549,8.549,0,0,0-1.59-3.1A8.443,8.443,0,0,0,9.239,5.994,11.692,11.692,0,0,0,4.894,4.929L5,23.346A11.685,11.685,0,0,0,8.737,22.5a9.467,9.467,0,0,0,2.879-1.829,8.18,8.18,0,0,0,1.86-2.586A7.815,7.815,0,0,0,14.171,14.963Z",
    transform: "translate(106.983 3.293) rotate(-10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blackboard",
    transform: "translate(52.443 92.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6357",
    "data-name": "Groupe 6357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6356",
    "data-name": "Groupe 6356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6355",
    "data-name": "Groupe 6355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13193",
    "data-name": "Trac\\xE9 13193",
    d: "M536.981,1268.8l1.75,3.754H515.9l1.749-3.754Z",
    transform: "translate(-493.48 -1213.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13194",
    "data-name": "Trac\\xE9 13194",
    d: "M305.263,1077.7l-3.555,7.627-2.264,4.854a.192.192,0,0,0-.013.031l-3.4,7.3H290.9l9.238-19.808Z",
    transform: "translate(-278.392 -1031.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13195",
    "data-name": "Trac\\xE9 13195",
    d: "M938.224,1077.7l9.239,19.808h-5.129l-3.414-7.323-2.256-4.842-.013-.026L933.1,1077.7Z",
    transform: "translate(-892.298 -1031.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13196",
    "data-name": "Trac\\xE9 13196",
    d: "M74.671,22.7v4.807H7V22.7Z",
    transform: "translate(-7 -22.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13197",
    "data-name": "Trac\\xE9 13197",
    d: "M161.94,157v39.458H102.7V157Z",
    transform: "translate(-98.484 -151.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13198",
    "data-name": "Trac\\xE9 13198",
    d: "M896.535,647.684a3,3,0,1,1-2.964-3.484A3.261,3.261,0,0,1,896.535,647.684Z",
    transform: "translate(-851.676 -616.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13199",
    "data-name": "Trac\\xE9 13199",
    d: "M553.1,442.955h-7l3.5-10.055Z",
    transform: "translate(-522.348 -414.827)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "\\u062A",
    d: "M0,13.465A27.646,27.646,0,0,1,1.14,6.956l3.246.588A30.574,30.574,0,0,0,3.833,11.8c0,4.016,3.074,5.4,10.085,5.4,8.15,0,10.291-1.281,10.291-3.22a40.053,40.053,0,0,0-.829-6.162L27.426,7.2a40.006,40.006,0,0,1,.587,6.058c0,2.734-.45,4.466-1.692,5.711-1.936,1.94-6.5,2.979-13.577,2.979C2.935,21.947,0,18.969,0,13.465ZM14.748,2.833Q14.748,0,17.4,0T20.06,2.833a2.793,2.793,0,0,1-.734,2.021,2.649,2.649,0,0,1-1.924.733q-2.655,0-2.655-2.754Zm-6.673,0A2.809,2.809,0,0,1,8.854.753,2.665,2.665,0,0,1,10.827,0q2.7,0,2.7,2.833a2.741,2.741,0,0,1-.756,2.021,2.629,2.629,0,0,1-1.948.733A2.435,2.435,0,0,1,8.075,2.833Z",
    transform: "translate(19.832 13.45)",
    fill: "#eac676"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwladLogo);
export default __webpack_public_path__ + "static/media/awlad-logo.eb8fdd6c.svg";
export { ForwardRef as ReactComponent };